"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROPS_EXPANDED = exports.PropsExpanderDict = void 0;

var props_id_1 = require("./entities/props-id");

var PropsExpanderDict =
/** @class */
function () {
  function PropsExpanderDict() {
    this._expanded = {};
    this.setExpanded(props_id_1.PropsId.targetLinks, true);
    this.setExpanded(props_id_1.PropsId.sharedWith, true);
    this.setExpanded(props_id_1.PropsId.usedBy, true);
    this.setExpanded(props_id_1.PropsId.config, true);
    this.setExpanded(props_id_1.PropsId.health, true);
    this.setExpanded(props_id_1.PropsId.podStages, true);
    this.setExpanded(props_id_1.PropsId.resourceRoleMatrix, true);
  }

  PropsExpanderDict.prototype.setExpanded = function (key, value) {
    this._expanded[key] = value;
  };

  PropsExpanderDict.prototype.get = function (id) {
    var value = this._expanded[id];

    if (value) {
      return true;
    }

    return false;
  };

  return PropsExpanderDict;
}();

exports.PropsExpanderDict = PropsExpanderDict;
exports.PROPS_EXPANDED = new PropsExpanderDict();